import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=43b0c585&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=43b0c585&prod&lang=css"
import style1 from "./PanelGroup.vue?vue&type=style&index=1&id=43b0c585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b0c585",
  null
  
)

export default component.exports